class FiskalyDeController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'configurationOptions'
		'ToastService'

	integrationId: 'fiskaly_de'

	initialize: ->
		@autoEnroll = !@configuration.is_active

	save: ->
		if !@configuration.is_active && @autoEnroll
			delete @configuration.tss_id
			delete @configuration.admin_pin

		super(@configuration)
			.then (response) =>
				@configuration = response.data

				if response.data.__warnings?.fiskaly?
					@ToastService.showWarnings(response.data.__warnings.fiskaly)

	afterDisconnect: ->
		@autoEnroll = true
		@configuration =
			is_active: false
